export const KNOB_MAX_INNER_CIRCLE_RADIUS = "7.5";
export const KNOB_MIN_INNER_CIRCLE_RADIUS = "5.5";
export const OFF = "Off";
export const ON = "On";